export default __webpack_public_path__ + "static/media/appIcon.c6293c2e.svg";